import { render } from "./SwdInputNumber.vue?vue&type=template&id=42a038b1"
import script from "./SwdInputNumber.vue?vue&type=script&lang=js"
export * from "./SwdInputNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__